export default __webpack_public_path__ + "static/media/rakeback-2.27d148ab.png";